import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { AppConfig } from '../config/config';
import { F11CrudCreate } from '../models/feeder11.model';

@Injectable({
  providedIn: 'root'
})
export class F11Service {

  private pathApi = this.config.setting['pathApi'] + "feeder11/";

  constructor(private http: HttpClient, private config: AppConfig) { }

  getAll(dataIn: any): Observable<any> {
    return this.http.post(`${this.pathApi}getAll`, dataIn, {observe: 'response'});
  }

  save(f11: F11CrudCreate): Observable<any> {
    return this.http.post(`${this.pathApi}save`, f11, {observe: 'response'});
  }

  delete(id: number, record: string = ''): Observable<any> {
    const query = record ? `?record=${encodeURIComponent(record)}` : '';
    return this.http.delete(`${this.pathApi}delete/${id}${query}`, {observe: 'response'});
  }

  getAllForSelect(utilityId: number | null = null): Observable<any> {
    if(utilityId) {
      return this.http.get(`${this.pathApi}getAllForSelect/${utilityId}`, {observe: 'response'});
    }
    else {
      return this.http.get(`${this.pathApi}getAllForSelect`, {observe: 'response'});
    }
  }

  downloadFile(dataIn: any): Observable<any> {
    return this.http.post(`${this.pathApi}downloadFile`, dataIn);
  }
}
